import {
  getSelectedDistrict,
  getSelectedSchool,
  getSelectedSport,
  getSelectedState,
} from 'app/imports/App.selectors'
import { cszUrl } from 'features/Env'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export function useSchedulesLink() {
  const selectedState = useSelector(getSelectedState)
  const selectedDistrict = useSelector(getSelectedDistrict)
  const selectedSchool = useSelector(getSelectedSchool)
  const selectedSport = useSelector(getSelectedSport)

  const schedulesUrl = useMemo(() => {
    const queryParams = []

    if (selectedState && selectedState.length === 1) {
      queryParams.push(`selectedStateId=${selectedState[0].id}`)
    }

    if (selectedDistrict && selectedDistrict.length === 1) {
      queryParams.push(`countyId=${selectedDistrict[0].id}`)
    }

    if (selectedSchool && selectedSchool.length === 1) {
      queryParams.push(`schoolId=${selectedSchool[0].id}`)
    }

    if (selectedSport && selectedSport.length === 1) {
      queryParams.push(`selectedSportId=${selectedSport[0].id}`)
    }

    queryParams.push('force=true')

    return `${cszUrl}/schedules?${queryParams.join('&')}`
  }, [selectedDistrict, selectedSchool, selectedSport, selectedState])

  return { schedulesUrl }
}
